var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownPaymentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3418_3458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0665 9.55101H16.1006C15.9961 8.9297 15.9382 8.31318 15.7852 7.72237C14.9839 4.61822 12.0146 2.43676 8.85338 2.603C5.59355 2.77462 2.88706 5.20185 2.37801 8.41125C1.68116 12.8011 5.02603 16.6539 9.42621 16.5205C9.6329 16.5146 9.77168 16.5714 9.91341 16.7197C10.4124 17.2393 10.9262 17.7452 11.4465 18.2691C9.04058 19.047 5.06087 18.6356 2.35616 15.4256C-0.273557 12.3047 -0.487926 7.7433 1.83766 4.3856C4.18804 0.992023 8.47897 -0.362417 12.3093 1.10265C16.2093 2.59463 18.1486 6.35656 18.0665 9.55101Z",
    fill: "url(#paint0_linear_3418_3458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0689 16.0791C13.0689 15.9237 13.0689 15.8077 13.0689 15.691C13.0689 14.1769 13.0689 12.6634 13.0689 11.1493C13.0689 10.6411 13.2006 10.5041 13.6908 10.5041C14.9398 10.5035 16.1888 10.5035 17.4378 10.5041C17.9581 10.5041 18.088 10.6351 18.088 11.1535C18.088 12.6676 18.088 14.1811 18.088 15.6952C18.088 15.8118 18.088 15.9285 18.088 16.0797C18.5244 16.0797 18.9254 16.0845 19.3264 16.0779C19.5685 16.0738 19.7835 16.1144 19.8862 16.3686C19.9896 16.6239 19.8561 16.8003 19.6855 16.9725C18.4518 18.2163 17.2229 19.4643 15.9904 20.71C15.6845 21.0191 15.4683 21.0203 15.1601 20.7088C13.9199 19.4572 12.6839 18.202 11.4432 16.9516C11.2754 16.7824 11.178 16.5988 11.2695 16.3644C11.3634 16.1234 11.569 16.075 11.8016 16.0785C12.2121 16.0839 12.6225 16.0803 13.0678 16.0803L13.0689 16.0791Z",
    fill: "url(#paint1_linear_3418_3458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89637 13.9953C9.89637 14.2405 9.88929 14.4587 9.89874 14.6758C9.90641 14.8624 9.84322 14.9521 9.64657 14.9467C9.32236 14.9377 8.99697 14.9383 8.67276 14.9467C8.48024 14.9515 8.4076 14.8684 8.4141 14.6788C8.42236 14.4408 8.41587 14.2022 8.41587 13.9445C6.72926 13.5869 5.79974 12.5661 5.6958 10.7853H7.19875C7.20761 10.7973 7.22591 10.8116 7.22827 10.8278C7.45977 12.3789 8.82394 12.718 9.97078 12.4734C10.2229 12.4196 10.4857 12.3102 10.6901 12.1547C11.254 11.7259 11.2038 10.936 10.5619 10.6442C10.0304 10.4026 9.44047 10.2944 8.87827 10.1192C8.33496 9.94992 7.77512 9.81478 7.25603 9.58754C5.50978 8.82331 5.68517 6.5994 6.91351 5.78375C7.35701 5.48954 7.8767 5.31194 8.41469 5.056C8.41469 4.91547 8.42059 4.68764 8.41292 4.4598C8.40642 4.27562 8.46607 4.18234 8.66449 4.18772C8.99874 4.19729 9.33358 4.1931 9.66783 4.18892C9.82905 4.18712 9.92472 4.25768 9.89106 4.41974C9.76763 5.01533 10.0535 5.22104 10.5903 5.40044C11.7507 5.78853 12.4529 6.87866 12.4033 8.04234H10.9357C10.9287 8.03457 10.9074 8.02261 10.905 8.00706C10.7155 6.8069 9.85208 6.48698 8.72354 6.61914C8.44953 6.65143 8.15898 6.7471 7.9263 6.89481C7.3765 7.24343 7.41016 7.9377 8.00248 8.19304C8.46784 8.39396 8.97925 8.48426 9.46764 8.63196C10.0505 8.80777 10.6499 8.94411 11.208 9.18151C13.1178 9.99298 12.9596 12.4076 11.5765 13.3656C11.0781 13.7107 10.5259 13.8948 9.89578 13.9947L9.89637 13.9953Z",
    fill: "url(#paint2_linear_3418_3458)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3418_3458",
    x1: 9.14877,
    y1: 0.517212,
    x2: 9.14877,
    y2: 18.6076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4935C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3418_3458",
    x1: 15.5784,
    y1: 10.5037,
    x2: 15.5784,
    y2: 20.9421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4935C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3418_3458",
    x1: 9.16207,
    y1: 4.1875,
    x2: 9.16207,
    y2: 14.9469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4935C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB0054"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3418_3458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.6948,
    height: 20.4242,
    fill: "white",
    transform: "translate(0.228516 0.517212)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownPaymentIcon);
export default __webpack_public_path__ + "static/media/down-payment-icon.86de64b9f8e7f11a24b7adeb9dfa02c2.svg";
export { ForwardRef as ReactComponent };